import SignaturePad from "signature_pad";

FirmaControlador.$inject = ["$timeout"];

export default function FirmaControlador($timeout) {

    var fc = this;

    var id = "";
    for (var i = 0; i < 6; i++) id += "" + Math.floor(Math.random() * 101);
    fc.id = id;
    var signaturePad = null;

    setTimeout(function () {
        var width = document.getElementById("firma-" + fc.id).offsetWidth;
        var canvas = document.getElementById("canvas-" + fc.id);
        if (width <= 400) {
            canvas.width = width;
            canvas.heigth = width;
        } else {
            canvas.width = 400;
            canvas.heigth = 400;
        }

        signaturePad = new SignaturePad(canvas);
        signaturePad.addEventListener("endStroke", () => {
            $timeout(function () {
                fc.firmaActualizada({data: signaturePad.toDataURL()});
            });
        });

        if (fc.firma != null && fc.firma !== "") signaturePad.fromDataURL(fc.firma);

    }, 200);

    fc.borrar = function () {
        signaturePad.clear();
        fc.firmaActualizada({data: null});
    };
}
